import { useCallback, useMemo } from 'react';
import webBiLogger from '@wix/web-bi-logger';

interface LogObject {
  evid: number;
  endpoint: string;
  src: number;
  params: { [key: string]: any };
}

export const useBi = () => {
  const biLogger = useMemo(() => webBiLogger.factory().logger(), []);

  const report = useCallback(
    async (event: LogObject): Promise<void> => {
      await biLogger.report(event);
    },
    [biLogger],
  );

  return { report };
};
